//import logo from './logo.svg';
import "./App.css";
import "./assets/css/bootstrap.min.css";
//import './assets/css/font-awesome.min.css';
import "./assets/css/main.css";
import "./assets/css/rpd.css";
import { Amplify } from "aws-amplify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/auth/AuthContext";
import Header from "./components/Header";
import TOTD from "./components/Totd";
import Terms from "./components/Terms";
import Dutch from "./components/Dutch";
import Privacy from "./components/Privacy";
import Support from "./components/Support";
import AccountDeletion from "./components/AccountDeletion";
import About from "./components/About";
import Footer from "./components/Footer";
import Drink from "./components/Drink";

Amplify.configure({
    Auth: {
        region: "ap-southeast-2",
        userPoolId: "ap-southeast-2_Ar79EBArz",
        userPoolWebClientId: "1f7ph2vfcoandd21kkpgj3jbqp",
        // refreshHandlers: {
        //   'developer': refreshToken
        // }
    },
});

function App() {
    return (
        <AuthProvider>
            <Router basename="/">
                <Header />
                <Drink />
                <Routes>
                    <Route exact path="/" element={<TOTD />} />
                    <Route exact path="/Terms/" element={<Terms />} />
                    <Route exact path="/Privacy/" element={<Privacy />} />
                    <Route exact path="/Terms" element={<Terms />} />
                    <Route exact path="/Privacy" element={<Privacy />} />
                    <Route exact path="/Support/" element={<Support />} />
                    <Route exact path="/Support" element={<Support />} />
                    <Route exact path="/Account-Deletion/" element={<AccountDeletion />} />
                    <Route exact path="/Account-Deletion" element={<AccountDeletion />} />
                    <Route exact path="/Delete-Account/" element={<AccountDeletion />} />
                    <Route exact path="/Delete-Account" element={<AccountDeletion />} />
                    <Route exact path="/Dutch" element={<Dutch />} />
                    <Route exact path="/About" element={<About />} />
                    <Route exact path="/About/" element={<About />} />
                    <Route exact path="/Dutch/" element={<Dutch />} />
                </Routes>
                <Footer />
            </Router>
        </AuthProvider>
    );
}

export default App;
